import { render } from "./applyForm.vue?vue&type=template&id=55b55306&scoped=true"
import script from "./applyForm.vue?vue&type=script&lang=js"
export * from "./applyForm.vue?vue&type=script&lang=js"

import "./applyForm.vue?vue&type=style&index=0&id=55b55306&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-55b55306"]])

export default __exports__